import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivityGroupTable from '@activities/components/tables/activity-group-table/activity-group-table.vue';

@Component({
  name: 'bpc-activity-groups',
  components: {
    'bpc-activity-group-table': ActivityGroupTable,
  },
})
export default class ActivityGroups extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
